/* eslint-disable no-param-reassign */
export default {
  SET_TABLE_CACHE(state, { tableKey, cacheKey, payload }) {
    if (!state.tables[tableKey]) state.tables[tableKey] = {}
    state.tables[tableKey][cacheKey] = payload
  },
  MARK_TABLE_CACHE_STALE(state, { tableKey }) {
    if (state.tables[tableKey]) {
      Object.values(state.tables[tableKey]).forEach(cache => {
        cache.stale = true
      })
    }
  },
  CLEAR_TABLE_CACHE(state, tableKey) {
    if (tableKey) {
      state.tables[tableKey] = {}
    } else {
      state.tables = {}
    }
  },
}
